import { SystemCommonView } from './component/index';
import { defineComponent, inject } from 'vue';
import { IMsg } from '_c/typings/model/im';
import { SystemMsg, MsgSystemType } from '_c/typings/proto';

type SystemMessageViewData = {
  message: IMsg;
};

export default defineComponent({
  name: 'SystemMessageView',
  components: {
    SystemCommonView,
  },
  data(): SystemMessageViewData {
    return {
      message: inject('messageData') as IMsg,
    };
  },
  computed: {
    systemMsg(): SystemMsg | null {
      return this.message.systemMsg || null;
    },
    type(): MsgSystemType {
      return this.systemMsg?.systemType as MsgSystemType;
    },
    isCommon(): boolean {
      return this.type === MsgSystemType.MsgSystemTypeUnknown
        || this.type === MsgSystemType.MsgSystemTypeBlockMsg
        || this.type === MsgSystemType.MsgSystemTypeAdminChangeSystemMsg
        || this.type === MsgSystemType.MsgSystemTypeChannelNotice
        || this.type === MsgSystemType.MsgSystemTypeGroupNickNameRuleSet;
    },
  },
});
